import React, { FC, useMemo } from 'react';
import { Container, Section } from '@printdeal/ui-library';
import LayoutSection from '../../layout-section/LayoutSection';
import { getSectionData } from '../helpers';
import { HomepageSectionProps } from '../types';
import { EmailOptInForm, FormSectionForm } from '../../email-opt-in-form/EmailOptInForm';
import SeoContent from '../../seo-content/SeoContent';
import { SystemPageSeoPropType } from '../../../types/systemPageSeo';

export interface SeoSectionProps {
  section?: HomepageSectionProps;
}

export const SeoSection: FC<SeoSectionProps> = ({
  section,
}) => {
  const {
    emailOptinFormContent,
    pageContent,
  } = useMemo(
    () => ({
      emailOptinFormContent: getSectionData(section, 'email_optin_form') as FormSectionForm,
      pageContent: getSectionData(section, 'seo_information') as SystemPageSeoPropType,
    }),
    [section],
  );

  return (
    <Section
      as={LayoutSection}
      variant={section?.backgroundStyle || 'white'}
      withSidebar={false}
      withDivider={false}
      backgroundColor=""
      className="pd-py-7 lg:pd-py-14"
    >
      <Container className="pd-grid pd-gap-7 lg:pd-gap-14">
        {emailOptinFormContent?.hubspotForm && (
          <EmailOptInForm
            hubspotFormId={emailOptinFormContent.hubspotForm}
            title={emailOptinFormContent.title}
            description={emailOptinFormContent.description}
            className="pd-rounded pd-bg-dim-100 pd-px-4 pd-py-12 md:pd-p-12"
            variant="horizontal"
          />
        )}
        {pageContent?.contentField1 && (
          <SeoContent content={pageContent.contentField1} />
        )}
      </Container>
    </Section>
  );
};
